module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/flow_img_sp-0dc8c17f787d4226926ca4d992cc3828.png";